// src/services/disciplinePhotoServices.js

import axios from "axios";

const _base =
  (typeof import.meta !== "undefined" &&
    import.meta.env &&
    import.meta.env.VITE_API_URL) ||
  process.env.REACT_APP_API_URL ||
  "";

const baseUrl = _base.replace(/\/$/, "");
const apiUrl = `${baseUrl}/api/disciplines`;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const extractDisciplineImageUrl = (response) => {
  if (!response) return "";

  return (
    response?.image_discipline ||
    response?.photo_url ||
    response?.imageUrl ||
    response?.url ||
    response?.path ||
    response?.data?.image_discipline ||
    response?.data?.photo_url ||
    response?.data?.imageUrl ||
    response?.data?.url ||
    response?.data?.path ||
    ""
  );
};

export const uploadDisciplinePhoto = async (
  disciplineId,
  file,
  options = {}
) => {
  if (!disciplineId) throw new Error("disciplineId requis");
  if (!file) throw new Error("file requis");

  const { format = "webp", onUploadProgress } = options;

  const form = new FormData();
  form.append("file", file);

  try {
    const { data } = await axios.patch(
      `${apiUrl}/${encodeURIComponent(
        disciplineId
      )}/photo?format=${encodeURIComponent(format)}`,
      form,
      {
        headers: {
          ...authHeaders(),
        },
        onUploadProgress,
      }
    );

    return {
      ...data,
      image_discipline: extractDisciplineImageUrl(data),
    };
  } catch (error) {
    console.error("[uploadDisciplinePhoto] erreur:", error);
    throw error?.response?.data || error?.message || error;
  }
};

export const cropDisciplinePhoto = async (disciplineId, crop = {}) => {
  if (!disciplineId) throw new Error("disciplineId requis");

  const { x, y, width, height, format, src } = crop;
  const nums = [x, y, width, height];

  if (nums.some((value) => typeof value !== "number" || Number.isNaN(value))) {
    throw new Error("x, y, width, height numériques requis");
  }

  const payload = { x, y, width, height };

  if (format) payload.format = format;
  if (src) payload.src = src;

  try {
    const { data } = await axios.patch(
      `${apiUrl}/${encodeURIComponent(disciplineId)}/photo/crop`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          ...authHeaders(),
        },
      }
    );

    return {
      ...data,
      image_discipline: extractDisciplineImageUrl(data),
    };
  } catch (error) {
    console.error("[cropDisciplinePhoto] erreur:", error);
    throw error?.response?.data || error?.message || error;
  }
};

export const toAbsolutePhotoUrl = (photoUrl) => {
  if (!photoUrl) return "";

  const value = String(photoUrl).trim();

  if (
    /^https?:\/\//i.test(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  if (value.startsWith("/uploads/")) {
    return `${baseUrl}${value}`;
  }

  return value;
};